/* eslint-disable */
export default {
    state: {
        searchingPostCount: false,
        searchPostCount: undefined,
        searchingUserCount: false,
        searchUserCount: undefined,
        users: [],
        usersLoading: false,
        usersLoadMore: 0,
        usersLoadingMore: false,
        statusOk: false,
        message: ""
    },
    mutations: {
        'ADVANCED_SEARCHING_POST_COUNT' (state, val) {
            state.searchingPostCount = val;
        },
        'ADVANCED_SEARCH_POST_COUNT' (state, val) {
            state.searchPostCount = val;
        },
        'ADVANCED_SEARCHING_USER_COUNT' (state, val) {
            state.searchingUserCount = val;
        },
        'ADVANCED_SEARCH_USER_COUNT' (state, val) {
            state.searchUserCount = val;
        },
        'ADVANCED_USERS_LOADING' (state, val) {
            state.usersLoading = val;
        },
        'ADVANCED_USERS_SUCCESS' (state, val) {
            if(!val.lastIDExists) state.users = [];
            val.response.forEach(item => {
                let valid = true;
                for(let i=0; i<state.users.length; i++) {
                    if(state.users[i]._id === item._id) {
                        valid = false; break;
                    }
                }
                if(valid)state.users.push(item);
            });
            state.usersLoadMore = val.loadMore;
            state.statusOk = true;
            state.message = "";
        },
        'ADVANCED_USERS_ERROR' (state, val) {
            state.statusOk = false;
            state.message = val;
        },
        'ADVANCED_USERS_LOADING_MORE' (state, val) {
            state.usersLoadingMore = val;
        }
    },
    actions: {
        'ADVANCED_SEARCH_FETCH_POSTS_COUNT' ({commit}, query) {
            console.log('query', JSON.stringify(query));
            query.searchType = "count";
            commit('ADVANCED_SEARCHING_POST_COUNT', true);
            axios.get(`/item`, {
                params: query
            })
            .then(resp => {
                commit('ADVANCED_SEARCHING_POST_COUNT', false);
                commit('ADVANCED_SEARCH_POST_COUNT', resp.data.response.total);
                console.log("count posts", resp);
            })
            .catch(err => {
                commit('ADVANCED_SEARCHING_POST_COUNT', false);
                commit('ADVANCED_SEARCH_POST_COUNT', 0);
                console.log("count posts err", err.response);
            });
        },
        'ADVANCED_SEARCH_FETCH_USERS_COUNT' ({commit}, query) {
            console.log("query", query);
            query.searchType = "count";
            commit('ADVANCED_SEARCHING_USER_COUNT', true);
            axios.get(`/user`, {
                params: query
            })
            .then(resp => {
                commit('ADVANCED_SEARCHING_USER_COUNT', false);
                commit('ADVANCED_SEARCH_USER_COUNT', resp.data.response.total);
                console.log("count posts", resp);
            })
            .catch(err => {
                commit('ADVANCED_SEARCHING_USER_COUNT', false);
                commit('ADVANCED_SEARCH_USER_COUNT', 0);
                console.log("count posts err", err.response);
            });
        },
        'ADVANCED_SEARCH_FETCH_USERS' ({commit}, query) {
            console.log("query", query);
            commit(query.lastID ? 'ADVANCED_USERS_LOADING_MORE':'ADVANCED_USERS_LOADING', true);
            axios.get(`/user`, {
                params: query
            })
            .then(resp => {
                commit(query.lastID ? 'ADVANCED_USERS_LOADING_MORE':'ADVANCED_USERS_LOADING', false);
                resp.data.lastIDExists = !!query.lastID;
                commit('ADVANCED_USERS_SUCCESS', resp.data);
                console.log("users", resp);
            })
            .catch(err => {
                commit(query.lastID ? 'ADVANCED_USERS_LOADING_MORE':'ADVANCED_USERS_LOADING', false);
                commit('ADVANCED_USERS_ERROR', "Error. Failed to load users.");
                console.log("users err", err.response);
            });
        }
    }
};